module.exports = __webpack_public_path__ + "img/智能巡视机器人.f5ea3a29.png";